import { render, staticRenderFns } from "./ProductFormItem.vue?vue&type=template&id=2ec6e4e4"
import script from "./ProductFormItem.vue?vue&type=script&lang=js"
export * from "./ProductFormItem.vue?vue&type=script&lang=js"
import style0 from "./ProductFormItem.vue?vue&type=style&index=0&id=2ec6e4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports